import { OdataManager } from '@/api/odata/odata-manager';
import { VolumeType } from '@/api/model/interfaces';

export default class VolumeTypeOdata extends OdataManager<VolumeType> {}
